import React, { Component } from 'react';
// import { Grid, Cell } from 'react-flexr';
import Button from 'react-bootstrap/lib/Button';
import Rating from '../results/result-row/common/rating';

export default class Item extends Component {
  render() {
    const { image, text, rating, link } = this.props;

    const orderText = this.props.orderText || 'Bestil tilbud';

    return (
      <div
        style={{
          textAlign: 'center',
          padding: '10px',
          border: '1px solid lightgrey',
          background: 'white'
        }}
      >
        <div
          style={{
            margin: '10px',
            height: 50,
            backgroundImage: `url(${image})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
          }}
        />

        {text ? <div style={{ padding: '10px 0' }}>{text}</div> : null}

        {rating ? (
          <div style={{ padding: '10px 0' }}>
            <Rating rating={rating} />
          </div>
        ) : (
          ''
        )}

        <div style={{ paddingTop: '10px' }}>
          <Button href={link} bsStyle="success">
            {orderText}
          </Button>
        </div>
      </div>
    );
  }
}
